import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Shield } from "lucide-react";

// LGPD Art. 7 §IX + Art. 11 II — base legal: consentimento
// para dados analíticos de uso. Dados clínicos tratados
// sob base legal distinta (Art. 11 II f — execução de serviço).
// Consentimento analítico é opcional e não condiciona o serviço.

const STORAGE_KEY = "akali_consent";

function readConsent() {
  try {
    return window.sessionStorage.getItem(STORAGE_KEY);
  } catch (err) {
    console.warn("ConsentBanner: sessionStorage read failed", err);
    return null;
  }
}

function writeConsent(value) {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, value);
  } catch (err) {
    console.warn("ConsentBanner: sessionStorage write failed", err);
  }
}

function initAnalytics() {
  // PostHog (or other analytics) gets initialized here when wired.
  // Currently a no-op stub — left intentionally for downstream integration.
  if (typeof window !== "undefined" && window.posthog?.init) {
    try {
      window.posthog.opt_in_capturing();
    } catch (err) {
      console.warn("ConsentBanner: posthog opt-in failed", err);
    }
  }
}

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!readConsent()) setVisible(true);
  }, []);

  const accept = () => {
    writeConsent("accepted");
    initAnalytics();
    setVisible(false);
  };

  const refuse = () => {
    writeConsent("refused");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="consent-banner"
          role="dialog"
          aria-label="Consentimento de cookies analíticos"
          data-testid="consent-banner"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="consent-banner-content">
            <div className="consent-banner-text">
              <Shield size={16} color="var(--color-accent)" style={{ flexShrink: 0 }} />
              <p>
                Usamos cookies analíticos para melhorar o produto. Seus dados
                clínicos nunca são usados para analytics.{" "}
                <Link
                  to="/privacidade"
                  className="consent-banner-link"
                  data-testid="consent-banner-learn-more"
                >
                  Saiba mais
                </Link>
              </p>
            </div>

            <div className="consent-banner-actions">
              <button
                type="button"
                className="consent-banner-btn-ghost"
                onClick={refuse}
                data-testid="consent-banner-refuse"
              >
                Recusar
              </button>
              <button
                type="button"
                className="consent-banner-btn-primary"
                onClick={accept}
                data-testid="consent-banner-accept"
              >
                Aceitar
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
